import * as Yup from 'yup';

export const ProfileAddReferenceFormValidationSchema = Yup.object().shape({
  Name: Yup.string()
    .nullable()
    .max(100, 'You have exceeded the maximum number of 100 characters')
    .required('Full Name field is required'),

  Email: Yup.string()
    .nullable()
    .max(100, 'You have exceeded the maximum number of 100 characters')
    .required('Email field is required'),

  Phone: Yup.string()
    .nullable()
    .max(30, 'You have exceeded the maximum number of 30 characters')
    .required('Phone Number field is required'),

  TitleID: Yup.object()
    .nullable()
    .required('Title field is required'),

  CompanyID: Yup.object()
    .nullable()
    .required('Company field is required'),
});
